import { REDUCER_NAME as PARENT_REDUCER_NAME } from '../const'
import { REDUCER_NAME } from './const'

const NS = PARENT_REDUCER_NAME + '/' + REDUCER_NAME + '/'

export const CHANGE_MODE = NS + 'CHANGE_MODE'

export const CHANGE_FUNNEL_START_DEFINITION = NS + 'CHANGE_FUNNEL_START_DEFINITION'

export const CHANGE_FUNNEL_STEP = NS + 'CHANGE_FUNNEL_STEP'

export const FIND_COHORT_REQUEST = NS + 'FIND_COHORT_REQUEST'
export const FIND_COHORT_SUCCESS = NS + 'FIND_COHORT_SUCCESS'
export const FIND_COHORT_ERROR = NS + 'FIND_COHORT_ERROR'


export const FIND_CURRENT_STATE_REQUEST = NS + 'FIND_CURRENT_STATE_REQUEST'
export const FIND_CURRENT_STATE_SUCCESS = NS + 'FIND_CURRENT_STATE_SUCCESS'
export const FIND_CURRENT_STATE_ERROR = NS + 'FIND_CURRENT_STATE_ERROR'



// WEBPACK FOOTER //
// ./src/modules/analytics/state/funnel-builder/type.js